module.exports = __webpack_public_path__ + "static/media/corly.fdaae1bc.jpg";